import React from 'react'

import { Head } from '../Head'

export interface ErrorViewProps {
  title?: string
  headline?: string
  text?: string
  image?: React.ReactNode
  content?: React.ReactNode
}

export const ErrorView: React.FC<ErrorViewProps> = ({
  title,
  headline,
  text,
  image,
  content,
}) => {
  return (
    <>
      {title && <Head title={title} />}
      <div className="box-error">
        {image && image}
        {headline && <h3>{headline}</h3>}
        {text && <p className="text-muted">{text}</p>}
        {content && content}
      </div>
    </>
  )
}
